<template>
  <div class="wrapper">
    <span class="wrapper__title">{{ title }}</span>

    <slot />
  </div>
</template>

<script>
export default {
  name: 'InputWrapper',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: block;
  margin-top: 20px;

  &__title {
    display: block;
    margin-bottom: 6px;
  }
}
</style>
